import "./App.css";
import React, { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Top from "./screens/Top";
import Contact from "./screens/Contact";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import CompanyOverview from "./screens/CompanyOverview.js";
import OrgChart from "./screens/OrgChart.js";
import Blogs from "./screens/Blogs.js";
import ThankYou from "./screens/ThankYou.js";
import UIUXDesign from "./screens/Services/UIUXDesign.js";
import ResponsiveWebsites from "./screens/Services/ResponsiveWebsites.js";
import ReactJSDevelopment from "./screens/Services/ReactjsDevelopment.js";
import SEOOptimization from "./screens/Services/SEOOptimization.js";
import CMSSolutions from "./screens/Services/CMSSolutions.js";
import WebSecurity from "./screens/Services/WebSecurity.js";
import NLPSolutions from "./screens/Services/NLPSolutions.js";
import ComputerVision from "./screens/Services/ComputerVision.js";
import MachineLearning from "./screens/Services/MachineLearning.js";
import DataAnalytics from "./screens/Services/DataAnalytics.js";
import AIAutomation from "./screens/Services/AIAutomation.js";
import AIforBI from "./screens/Services/AIforBI.js";
import CRMSolutions from "./screens/Services/CRMSolutions.js";
import FinanceAutomation from "./screens/Services/FinanceAutomation.js";
import BusinessCentral from "./screens/Services/BusinessCentral.js";
import FieldService from "./screens/Services/FieldService.js";
import AIInsights from "./screens/Services/AIInsights.js";
import Customizations from "./screens/Services/Customizations.js";

const App = () => {
  const [isHideContent, setIsHideContent] = useState(false);

  const handleHideContent = (isHideContent) => {
    setIsHideContent(isHideContent);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div
      className={`App ${isHideContent ? "overflow-hidden" : ""}`}
    >
      <BrowserRouter>
        <Navbar onHideContent={handleHideContent} />
        <div className="nav-1"></div>
        <Routes>
          <Route
            path="/"
            element={
              <Top/>
            }
          />
          <Route path="/Responsive-Websites" element={<ResponsiveWebsites />} />
          <Route path="/UI-UX-Design" element={<UIUXDesign />} />
          <Route path="/Reactjs-Development" element={<ReactJSDevelopment />} />
          <Route path="/SEO-Optimization" element={<SEOOptimization />} />
          <Route path="/CMS-Solutions" element={<CMSSolutions />} />
          <Route path="/Web-Security" element={<WebSecurity />} />
          <Route path="/NLP-Solutions" element={<NLPSolutions />} />
          <Route path="/Computer-Vision" element={<ComputerVision />} />
          <Route path="/Data-Analytics" element={<DataAnalytics />} />
          <Route path="/Machine-Learning" element={<MachineLearning />} />
          <Route path="/AI-Automation" element={<AIAutomation />} />
          <Route path="/AI-for-BI" element={<AIforBI />} />
          <Route path="/CRM-Solutions" element={<CRMSolutions />} />
          <Route path="/Finance-Automation" element={<FinanceAutomation />} />
          <Route path="/Business-Central" element={<BusinessCentral />} />
          <Route path="/Field-Service" element={<FieldService />} />
          <Route path="/AI-Insights" element={<AIInsights />} />
          <Route path="/Customization" element={<Customizations />} />
          <Route path="/About-Us" element={<CompanyOverview />} />
          <Route path="/Org-Chart" element={<OrgChart />} />
          <Route path="/Blogs" element={<Blogs />} />
          <Route path="/contact" element={<Contact />} />
          <Route
            path="/ThankYou"
            element={<ThankYou />}
          />
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
};

export default App;
